import { ref } from 'vue';

export const useAsyncData = (fetcher, { immediate = true } = {}) => {
  const data = ref(null);
  const isLoading = ref(false);
  const isError = ref(false);
  let requestId = 0;

  const execute = async () => {
    const currentRequestId = ++requestId;
    isLoading.value = true;
    isError.value = false;

    try {
      const result = await fetcher();
      if (currentRequestId === requestId) data.value = result;
    } catch {
      if (currentRequestId === requestId) isError.value = true;
    } finally {
      if (currentRequestId === requestId) isLoading.value = false;
    }
  };

  const reset = () => {
    requestId++;
    data.value = null;
    isLoading.value = false;
    isError.value = false;
  };

  if (immediate) execute();

  return { data, isLoading, isError, execute, reset };
};
